import { render, staticRenderFns } from "./newNav.vue?vue&type=template&id=5c06d184&scoped=true&"
import script from "./newNav.vue?vue&type=script&lang=js&"
export * from "./newNav.vue?vue&type=script&lang=js&"
import style0 from "./newNav.vue?vue&type=style&index=0&id=5c06d184&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06d184",
  null
  
)

export default component.exports